const DEVICE_CODE_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:device_code'
const DEVICE_CODE_SUCCESS_CODE_TYPE = 'imagine.login.deviceCodeRequestSuccessful'
const JSON_PRE = 'data:application/json;base64,'
const JWT_TOKEN_TYPE = 'Bearer'
const NONCE_CHARS = [ 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
  'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B',
  'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
  'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3',
  '4', '5', '6', '7', '8', '9' ]
const OAUTH_PARAM_SEP = ','
const OAUTH_SIGNATURE_METHOD_HMAC_SHA1 = 'HMAC-SHA1'
const OAUTH_SIGNATURE_METHOD_PLAINTEXT = 'PLAINTEXT'
const OAUTH_SIGNATURE_METHOD_RSA_SHA1 = 'RSA-SHA1'
const PAYLOAD_TYPE_2FA_REQUIRE_ENROLL = '2FARequireEnroll'
const PAYLOAD_TYPE_2FA_VERIFY = '2FAVerify'
const PROFILE_TYPE_API_ACCESS = 'apiAccess'

export {
  DEVICE_CODE_GRANT_TYPE,
  DEVICE_CODE_SUCCESS_CODE_TYPE,
  JSON_PRE,
  JWT_TOKEN_TYPE,
  NONCE_CHARS,
  OAUTH_PARAM_SEP,
  OAUTH_SIGNATURE_METHOD_HMAC_SHA1,
  OAUTH_SIGNATURE_METHOD_PLAINTEXT,
  OAUTH_SIGNATURE_METHOD_RSA_SHA1,
  PAYLOAD_TYPE_2FA_REQUIRE_ENROLL,
  PAYLOAD_TYPE_2FA_VERIFY,
  PROFILE_TYPE_API_ACCESS,
}
